import { useTranslation } from 'react-i18next';
import { getItemWidth } from '../../../../../helpers/dnd/utilities';
import { FlattenedItem } from '../../../../shared/dnd/types';

interface Props {
  item: FlattenedItem,
  indentationWidth: number;
  depth: number;
  maximumUncollapsedDepth: number;
}

export default function RODefaultServiceDetails(props: Props) {
  const { item, indentationWidth, depth, maximumUncollapsedDepth } = props;
  const { t } = useTranslation();

  return (
    <div className='p-2.5 pr-5 flex border border-t-0 rounded-bl rounded-br border-cgray-300 text-xs 2xl:text-sm text-cgray-400 z-20 bg-white'>
      <div
        className="flex justify-end"
        style={{ width: `${getItemWidth(maximumUncollapsedDepth, indentationWidth, depth)}px` }}
      ></div>
      <div className="flex flex-col w-full gap-2 text-sm text-cgray-600 whitespace-normal">
        <div className="grid grid-cols-12 w-full gap-2 text-sm text-cgray-600">
          <div className="col-span-4 border border-cgray-200 rounded-t cursor-default flex flex-col pl-2 py-px">
            <p className=" text-2xs text-cgray-400">{t('Description')}</p>
            <input
              id="serviceDescription"
              readOnly
              name="serviceDescription"
              value={item.service?.description}
              className='w-full border-none rounded-t ring-0 outline-none cursor-default'
            />
          </div>
          <div className="col-span-1"></div>
          <div className='col-span-7 justify-self-end'></div>
          <div className='h-36 border border-cgray-200 cursor-default col-span-4 flex flex-col pl-2 py-px rounded-t'>
            <p className=" text-2xs text-cgray-400">{t('Notes')}</p>
            <textarea
              id={'serviceNotes'}
              name={'serviceNotes'}
              readOnly
              value={item.service?.notes as string}
              className='cursor-default resize-none overflow-ellipsis w-full h-full p-0 text-sm flex items-start border-none ring-0 outline-none bg-transparent shadow-none drop-shadow-none focus:border-none focus:ring-0 focus:outline-none'
            />
          </div>
        </div>

      </div>
    </div>
  );
}
